/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export {COMPILER_PROVIDERS__POST_R3__ as ÉµCOMPILER_PROVIDERS__POST_R3__, CompilerImpl as ÉµCompilerImpl} from './compiler_factory';
export {platformCoreDynamic as ÉµplatformCoreDynamic} from './platform_core_dynamic';
export {INTERNAL_BROWSER_DYNAMIC_PLATFORM_PROVIDERS as ÉµINTERNAL_BROWSER_DYNAMIC_PLATFORM_PROVIDERS} from './platform_providers';
export {ResourceLoaderImpl as ÉµResourceLoaderImpl} from './resource_loader/resource_loader_impl';
